import { useEffect, useState } from "react";
import FloatingWhatsApp from "react-floating-whatsapp";

export default function WhatsappWidget() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 500);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 9999,
        opacity: visible ? 1 : 0,
        transform: visible ? "scale(1)" : "scale(0.8)",
        pointerEvents: visible ? "auto" : "none",
        transition: "opacity 0.25s ease, transform 0.25s ease",
      }}
    >
      <FloatingWhatsApp
        phoneNumber="+254722822595​"
        accountName="Finecheck"
        chatMessage="Hello 👋, how can we help you?"
        statusMessage="Online"
        notification={false}
        notificationSound={false}
        allowClickAway={true}
        avatar="contact_us.png"
      />
    </div>
  );
}
